export default {
  data() {
    return {
      is_show_loading: false,
    };
  },
  methods: {
    async with_loading(async_operation, error_handler = null) {
      this.is_show_loading = true;
      try {
        return await async_operation();
      } catch(e) {
        if (error_handler) {
          error_handler(e);
        } else {
          this.$emit('emit_error', e);
        }
      } finally {
        this.is_show_loading = false;
      }
    },
  },
};
